import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IInstallationRequestDto } from "../../type/installation/debugInstallationTypes"
import { IInstallationDto } from "../../type/installation/installationTypes"

export interface IDebugInstallationStoreAddition {
    debugInstallation: IDebugInstallationSliceState
}

interface IDebugInstallationSliceState {
    installations: { [swMerchantId: string]: IInstallationDto[] | undefined }
    requests: { [installationId: string]: IInstallationRequestDto[] | undefined }
}

const initialState: IDebugInstallationSliceState = {
    installations: {},
    requests: {},
}

export const debugInstallationSlice = createSlice({
    name: "debugInstallation",
    initialState,
    reducers: {
        setDebugInstallations: (state, action: PayloadAction<{ installations: IInstallationDto[]; swMerchantId: string }>) => {
            state.installations[action.payload.swMerchantId] = action.payload.installations
        },
        setDebugInstallationRequests: (
            state,
            action: PayloadAction<{ requests: IInstallationRequestDto[] | undefined; installationId: string }>
        ) => {
            state.requests[action.payload.installationId] = action.payload.requests
        },
    },
})

export const debugInstallationActions = debugInstallationSlice.actions
export const debugInstallationSelectors = {
    installations: (state: IDebugInstallationStoreAddition, swMerchantId: string) =>
        state.debugInstallation.installations[swMerchantId],
    requests: (state: IDebugInstallationStoreAddition, installationId: string) =>
        state.debugInstallation.requests[installationId],
}
